import ProvidesContacts from "../../mixins/provides-contacts";
import HasLeaseContactGroup from "../../mixins/has-lease-contact-group";
import ComposeMail from "../../mixins/compose-mail";
import TabState from "../../mixins/tab-state";
import { mapGetters } from "vuex";
import AcceptedMimeTypes from "../../mixins/accepted-mime-types";
import ArchivingMixin from "../../mixins/archiving-mixin";

Vue.component("view-inspection", {
    mixins: [TabState, ProvidesContacts, ComposeMail, AcceptedMimeTypes, HasLeaseContactGroup, ArchivingMixin],

    props: {
        inspection: {},
        inspectionTypes: {
            type: Array
        },
        tickets: {
            type: Array
        },
        juristicEntityTypes: {
            type: Array
        },
        titleOptions: {
            type: Array
        },
        assetGroup: {
            type: Object
        },
    },

    data () {
        return {
            mutableInspection: {},
            checklistAreas: [],
            areaFilter: "all",
            checklistSearchFilter: "",
            recommendationsOnlyFilter: false,
            selectedArea: {},
            selectedChecklistItem: {},
            isLoadingChecklist: true,
            showPhotosPanel: false,
            showEmailsPanel: false,
            reportForm: new AppForm({
                number_of_signature_blocks: 4
            }),
            emailContext: {},
            inspectionTickets: this.tickets,
            itemSelectionMode: false,
            selectedChecklistItems: [],
            showInspectionSharingForm: false,
            showTicketCreateModal: false,
            showInspectionTicketLinkingForm: false,
            showInspectionAreaReorderingModal: false,
            hideIfEmpty: false,
        };
    },
    computed: {
        ...mapGetters(["mutableEmailContext"]),
        selectedChecklistItemId () {
            if (this.selectedChecklistItem) {
                return this.selectedChecklistItem.id;
            }
            return null;
        },
        ticketItemsSelectionMessage () {
            if (this.selectedChecklistItems.length === 0) {
                return "Select the items you want to include in the maintenance ticket.";
            }

            if (this.selectedChecklistItems.length === 1) {
                return "1 Item selected";
            }

            return this.selectedChecklistItems.length + " Items selected";
        },

        showBusyCopyingView () {
            return (this.mutableInspection && this.mutableInspection.copy_started_at !== null) && !this.isLoadingChecklist;
        },

        showEmptyView () {
            return !this.isLoadingChecklist && !this.showBusyCopyingView &&
                (this.checklistAreas === undefined || this.checklistAreas.length === 0) &&
                this.mutableInspection.checklist_areas.length === 0;
        },
        photoGalleryUrl () {
            if (_.isEmpty(this.selectedChecklistItem)) {
                return "";
            }
            return "/inspections/items/" + this.selectedChecklistItem.id + "/photos";
        },
        photoUploadActionUrl () {
            return "/inspections/items/" + this.selectedChecklistItem.id + "/photos/upload";
        },
        photoGalleryTitle () {
            return this.selectedChecklistItem ? this.selectedChecklistItem.item + " photos" : "Photos";
        },
        recommendationFilterIcon () {
            return this.recommendationsOnlyFilter ? "/images/recommendation-full.svg" : "/images/recommendation-empty.svg";
        },
        contactsUrl () {
            return "/contacts/inspection/" + this.mutableInspection.id;
        },
        documentsListUrl () {
            return "/inspections/" + this.mutableInspection.id + "/documents";
        },
        documentUploadUrl () {
            return "/inspections/" + this.mutableInspection.id + "/documents/upload";
        },
        showAssetNotes: function showAssetNotes () {
            return this.hasAssetNotes || this.hasComplexNotes;
        },
        hasAssetNotes: function hasAssetNotes () {
            return this.mutableInspection.asset.notes !== null && this.mutableInspection.asset.notes.trim() !== "";
        },
        hasComplexNotes: function hasComplexNotes () {
            return this.assetGroup !== null && this.assetGroup.notes !== null && this.assetGroup.notes.trim() !== "";
        },
    },
    methods: {
        calculateRemainingListItems () {
            var items = 0;

            this.checklistAreas.forEach(function (a) {
                if (a.checklist_items) {
                    items += a.checklist_items.length;
                }
            });

            return 20;
        },
        checklistContainerHeight () {
            let element = this.$refs.checklist_view_container;
            var yPosition = 0;

            while (element) {
                yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
                element = element.offsetParent;
            }

            let preferredHeight = window.innerHeight - yPosition - 80;
            return preferredHeight > 310 ? preferredHeight : 310;
        },
        filterAreas (area) {
            this.areaFilter = area;
            this.fetchChecklist();
        },
        toggleRecommendationsOnlyFilter () {
            this.recommendationsOnlyFilter = !this.recommendationsOnlyFilter;
            this.fetchChecklist();
        },
        toggleHideIfEmpty () {
            this.hideIfEmpty = !this.hideIfEmpty;
            this.fetchChecklist();
        },
        submitSearch () {
            this.fetchChecklist();
        },
        resetFilters () {
            this.areaFilter = "all";
            this.checklistSearchFilter = "";
            this.recommendationsOnlyFilter = false;
        },
        fetchChecklist (callback) {
            if (this.showBusyCopyingView) {
                this.isLoadingChecklist = false;
                return;
            }

            this.isLoadingChecklist = true;
            axios.get("/inspections/" + this.mutableInspection.id + "/areas/all", {
                params: {
                    areaFilter: this.areaFilter,
                    checklistSearchFilter: this.checklistSearchFilter,
                    recommendationsOnlyFilter: this.recommendationsOnlyFilter,
                    hideIfEmpty: this.hideIfEmpty,
                }
            })
            .then(response => {
                this.checklistAreas = response.data;
                this.isLoadingChecklist = false;

                if (callback) {
                    callback();
                }

            })
            .catch(errors => {
                this.isLoadingChecklist = false;
                toastr.error("Error received while loading inspection areas");
            });

        },
        newAreaAdded (area) {
            this.hideAreaCreateForm();
            this.mutableInspection.checklist_areas.unshift(area);
            this.checklistAreas.unshift(area);

        },
        editArea (area) {
            this.selectedArea = area;
            $("#modal-inspection-area-edit-form").modal("show");
        },
        areaUpdated (area) {
            const result = this.checklistAreas.find(a => a.id === area.id);
            result.name = area.name;

            const areasFilterResult = this.inspection.checklist_areas.find(a => a.id === area.id);
            areasFilterResult.name = area.name;

            $("#modal-inspection-area-edit-form").modal("hide");
        },
        deleteArea (area) {
            let self = this;
            swal({
                title: "Delete " + area.name,
                text: "Are you sure you want to delete this area?",
                showCancelButton: true
            }).then((result) => {
                if (result.value) {
                    axios.post("/inspections/areas/" + area.id + "/delete", {_method: "DELETE"})
                    .then(() => {

                        const index = self.checklistAreas.indexOf(area);
                        if (index !== -1) {
                            self.checklistAreas.splice(index, 1);
                        }

                        const areaFilterIndex = self.mutableInspection.checklist_areas.findIndex(a => a.id == area.id);

                        if (areaFilterIndex !== -1) {
                            self.mutableInspection.checklist_areas.splice(areaFilterIndex, 1);
                        }

                        toastr.success(area.name + " Area deleted!");
                    })
                    .error(() => {
                        toastr.error("Area could not be deleted!");
                    });

                }
            });
        },
        /**
         * Emit event to have asset select component show
         * form for changing the asset
         */
        changeAsset () {
            Bus.$emit("show-asset-select-form");
        },
        reorderItems (area) {
            this.selectedArea = area;
            $("#modal-checklist-items-sorting").modal("show");
        },
        toggleReorderAreasModal () {
            this.showInspectionAreaReorderingModal = !this.showInspectionAreaReorderingModal;
        },
        syncAreasSequence () {
            this.fetchChecklist();
        },
        newItemAdded (item) {
            this.hideItemCreateForm();
            this.selectedArea.checklist_items.push(item);

        },
        editItem (item) {
            this.selectedChecklistItem = item;
            $("#modal-checklist-item-edit-form").modal("show");
        },
        toggleItemPhotosPanel (item) {
            if (!item) {
                this.showPhotosPanel = !this.showPhotosPanel;
                return;
            }

            this.selectedChecklistItem = item;
            this.showPhotosPanel = true;
        },
        itemUpdated (item) {
            // refresh checklist item with updated item
            const result = this.checklistAreas.find(area => area.id === item.inspection_area_id);
            const index = result.checklist_items.findIndex(i => i.id === item.id);

            // remove from selectedChecklistItems when choosing items to create a ticket from and then updating an item
            if (this.itemSelectionMode) {
                const index = this.selectedChecklistItems.findIndex(i => i.id === item.id);
                index > -1 ? this.selectedChecklistItems.splice(index, 1) : null;
            }

            this.$set(result.checklist_items, index, item);
        },
        itemDeleted (item) {
            const result = this.checklistAreas.find(area => area.id === item.inspection_area_id);

            const index = result.checklist_items.findIndex(i => i.id === item.id);
            result.checklist_items.splice(index, 1);

            toastr.success(item.item + " item deleted!");
        },
        showAreaCreateForm () {
            Bus.$emit("show-inspection-area-create-form");
        },
        hideAreaCreateForm () {
            Bus.$emit("hide-inspection-area-create-form");
        },
        showItemCreateForm (inspectionArea) {
            this.selectedArea = inspectionArea;
            $("#modal-checklist-item-create-form").modal("show");
        },
        hideItemCreateForm () {
            $("#modal-checklist-item-create-form").modal("hide");
        },
        afterArchiving (archiving) {
            if (archiving) {
                this.mutableInspection.archived_at = this.$dayjs().format();
            } else {
                this.mutableInspection.archived_at = null;
            }
        },
        inspectionCompleted () {
            Bus.$emit("inspection-completed", this.mutableInspection);
        },
        toggleEmailsPanel () {
            this.showEmailsPanel = !this.showEmailsPanel;
        },
        showReportSettings () {
            $("#modal-report-settings-form").modal("show");
        },
        generateReport (withOptions) {

            if (this.reportForm.include_signature_blocks === true && this.reportForm.number_of_signature_blocks < 1) {
                toastr.error("Please specify a number greater than 0 for the number of signature blocks to include in the report");
                return;
            }

            if (withOptions === false) {
                this.reportForm = new AppForm({});
            }

            $("#modal-report-settings-form").modal("hide");

            this.reportForm.provider = "browsershot";

            App.post("/inspections/" + this.mutableInspection.id + "/reports/generate", this.reportForm)
            .then(response => {
                toastr.success("Report Saved!");
                this.activateTab("documents");
                window.open(response.url, "_blank");
                Bus.$emit("document-added", response);
            })
            .catch(errors => {
                toastr.error("Error generating report: " + errors.message);
            });
        },
        shareDocument (document) {
            this.createEmail(null, document.id);
        },
        emailContact (contact) {
            const url = `/attachments/multi/inspection/${this.inspection.id}`;
            this.$store.dispatch("UPDATE_FILE_SELECTION_URL_FOR_CONTEXT", url);
            this.createEmail(contact.id, null);
        },
        createNewTicket () {
            if (this.selectedChecklistItems.length === 0) {
                toastr.error("Select items to add to ticket!");
            } else {
                this.showTicketCreateModal = true;
                this.toggleTicketItemsSelection();
            }
        },
        addItemsToExistingTicket () {
            if (this.selectedChecklistItems.length === 0) {
                toastr.error("Select items to add to ticket!");
            } else {
                this.toggleTicketItemsSelection();
                this.showInspectionTicketLinkingForm = true;
            }
        },
        toggleTicketItemsSelection () {
            this.itemSelectionMode = !this.itemSelectionMode;
            $(".dropdown-toggle").dropdown();
        },
        clearItemsSelection () {
            this.selectedChecklistItems = [];
            this.toggleTicketItemsSelection();
        },
        closeTicketCreation () {
            this.showTicketCreateModal = false;
            this.showInspectionTicketLinkingForm = false;
            this.selectedChecklistItems = [];
        },
        ticketCreated (response) {
            if (this.inspectionTickets.findIndex(t => t.id === response.ticket.id) === -1) {
                response.ticket.status = "open";
                this.inspectionTickets.push(response.ticket);
            }
            // Add ticket reference number to checklistItems
            this.checklistAreas.forEach(area => {
                response.selectedChecklistItems.forEach(selectedItem => {
                    let foundItem = area.checklist_items.find(checklistItem => checklistItem.id === selectedItem.id);
                    if (foundItem) {
                        foundItem.issues.push({
                            ticket_id: response.ticket.id,
                            inspection_ticket: {
                                priority: response.ticket.priority,
                                reference_number: response.ticket.ticket_reference_number,
                                status: response.ticket.status
                            }
                        });
                    }
                });
            });
            this.activateTab("tickets");
        },
        isChecklistItemSelected (itemId) {
            return this.selectedChecklistItems.indexOf(itemId) !== -1;
        },
        refreshPhotoList (args) {
            this.selectedChecklistItem = args;
            //this.$refs.photoList.fetchUrl = args;
            this.$refs.photoList.fetchPhotos();
            this.showPhotosPanel = true;
        },
        updateOnlineReportStatus (inspectionId, value) {
            // Event emits inspectionId but we don't need it here as we have mutableInspection
            // Value is either "not generated" or "generated" or "shared"
            this.$set(this.mutableInspection, "online_report_status", value);
        },
    },
    created () {
        this.mutableInspection = this.inspection;
    },
    mounted () {
        this.setSelectedContactGroup(this.inspection.lease_contact_group);
        this.usePushStateForTabs(".inspection-tabs");
        this.emailCreateUrl = "/inspections/" + this.inspection.id + "/emails/create";

        let self = this;

        Bus.$on("inspection-updated", function (inspection) {
            self.mutableInspection = inspection;
        });

        Bus.$on("first-photo-uploaded", function (photoUrl) {
            self.selectedChecklistItem.photo = photoUrl;
        });

        Bus.$on("last-photo-removed", function (photoUrl) {
            self.selectedChecklistItem.photo = "";
        });

        Bus.$on("item-selected", function (item) {
            let itemPos = self.selectedChecklistItems.findIndex(i => i.id === item.id);
            if (itemPos !== -1) {
                self.selectedChecklistItems.splice(itemPos, 1);
            } else {
                self.selectedChecklistItems.push(item);
            }
        });

        Bus.$on("ticket-linked", function (ticket) {
            if (self.inspectionTickets.findIndex(t => t.id === ticket.id) === -1) {
                self.inspectionTickets.push(ticket);
            }
            self.closeTicketCreation();
            self.activateTab("tickets");
            self.fetchChecklist();
        });

        this.fetchChecklist();
    }
});
